import React, { useState } from 'react';
import { Button, Drawer, Tabs } from "antd";
import { FaPaperclip } from "react-icons/fa6";
import { FileControl } from '../../../pages/file-control/file-control';

/* ปุ่มแนบไฟล์สำหรับ Goods Receipt (บันทึกตรวจรับวัตถุดิบ) — แยก 2 หมวด: COA / อื่นๆ */
const ButtonAttachFilesGR = ({ code, close = undefined, label = undefined, size = "small", disabled = false }) => {
    const [open, setOpen] = useState(false);
    return (
        <>
            <Button
                icon={<FaPaperclip />}
                className='bn-info-outline'
                style={{ cursor: "pointer", display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={(e) => setOpen(true)}
                size={size}
                disabled={disabled}
            >
                {label}
            </Button>
            <Drawer
                title={`แนบไฟล์ใบรับสินค้า : ${code || ""}`}
                placement="right"
                size="large"
                open={open}
                onClose={() => { setOpen(false); !!close && close(); }}
            >
                {open && (
                    <Tabs
                        defaultActiveKey="coa"
                        type="card"
                        items={[
                            {
                                key: "coa",
                                label: "COA",
                                children: (
                                    <FileControl
                                        title={`แนบไฟล์ COA สำหรับ Code : `}
                                        refcode={code}
                                        refs="Goods Receipt COA"
                                        noExpire={true}
                                        multiple={true}
                                    />
                                ),
                            },
                            {
                                key: "other",
                                label: "อื่นๆ",
                                children: (
                                    <FileControl
                                        title={`แนบไฟล์อื่นๆ สำหรับ Code : `}
                                        refcode={code}
                                        refs="Goods Receipt"
                                        noExpire={true}
                                    />
                                ),
                            },
                        ]}
                    />
                )}
            </Drawer>
        </>
    );
};

export default ButtonAttachFilesGR;
